require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-paul-conrad-lecture-for-melbourne-design-week.json") })
        }
      }, "path---journal-paul-conrad-lecture-for-melbourne-design-week");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-paul-conrad-lecture-for-melbourne-design-week!./.cache/json/journal-paul-conrad-lecture-for-melbourne-design-week.json
// module id = 522
// module chunks = 231608221292675